module.exports = __webpack_public_path__ + "static/email-template-canceled-subscription-3b5c90122ea8abc4c7536cca0c8f3ffb.jpg";